// Import the functions you need from the SDKs you need
import { initializeApp, getApps ,getApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "firebase/storage"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC_Euwc5P5QhKWsLRNTu1HVIqyLubwiwfE",
  authDomain: "rapidmindpower-71ae8.firebaseapp.com",
  databaseURL: "https://rapidmindpower-71ae8-default-rtdb.firebaseio.com",
  projectId: "rapidmindpower-71ae8",
  storageBucket: "rapidmindpower-71ae8.appspot.com",
  messagingSenderId: "343873687150",
  appId: "1:343873687150:web:b6b99498c553001c3ea07f",
  measurementId: "G-73DFBFQC2G"
};

// Initialize Firebase
const app =!getApps().length ? initializeApp(firebaseConfig) :getApp();

const db = getFirestore();
const storage = getStorage();
export {app,db,storage}